<!-- 内容审核与上下线 -->
<template>
  <div>
    <bread-crumb></bread-crumb>

    <div class="search-bar">
      <div class="input-group">
        <el-input
          style="width: 32%"
          v-model="searchParams.title"
          placeholder="请输入帖子标题"
          clearable
        ></el-input>
        <el-input
          style="width: 32%"
          v-model="searchParams.postIds"
          placeholder="请输入帖子ID"
          clearable
        ></el-input>
        <!-- <el-input style="width: 32%" v-model="searchParams.communityIds" placeholder="请选择所属圈子ID" clearable></el-input> -->
        <!-- <el-select style="width: 32%" v-model="searchParams.communityIds" filterable placeholder="请选择所属圈子ID" clearable>
          <el-option v-for="item in communityOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select> -->
        <el-select
          style="width: 32%"
          v-model="searchParams.communityIds"
          filterable
          remote
          placeholder="请选择所属圈子"
          :remote-method="remoteMethod"
          clearable
          @focus="onClearSelect"
          @clear="onClearSelect"
        >
          <el-option
            v-for="item in communityOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          style="width: 32%"
          v-model="searchParams.authorPin"
          placeholder="请输入发布者pin"
          clearable
        ></el-input>
        <el-input
          style="width: 32%"
          v-model="searchParams.titleSearchKeyword"
          placeholder="请输入帖子标题关键字"
          clearable
        ></el-input>
        <el-input
          style="width: 32%"
          v-model="searchParams.contentSearchKeyword"
          placeholder="请输入帖子全文关键字"
          clearable
        ></el-input>
        <el-select
          style="width: 32%"
          v-model="searchParams.communityType"
          placeholder="请选择用户关联话题"
          clearable
        >
          <el-option label="疾病圈" value="疾病圈"></el-option>
          <el-option label="症状圈" value="症状圈"></el-option>
          <el-option label="药品圈" value="药品圈"></el-option>
          <el-option label="兴趣圈" value="兴趣圈"></el-option>
        </el-select>
        <!-- <el-date-picker style="width: 52%" v-model="searchParams.contributeTime" type="datetimerange"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker> -->

        <div class="button-group">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </div>
      </div>
    </div>
    <div class="content-audit-tabel">
      <circle-table
        :tableData="tableData"
        @handleClick="TabhandleClick"
        :mulSelect="false"
        ref="table"
      ></circle-table>
    </div>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    ></pagination>
  </div>
</template>

<script>
import utils from "../../../../../utils";
import circleTable from "./circleTable.vue";
import manFormList from "../../../components/manFormList";
import breadCrumb from "../../../../../components/breadCrumb";
import pagination from "../../../../../components/pagination";
import {
  getAllArticleCounts,
  setArticleBadgeStatus,
  passOfflineArticle,
  rejectOfflineArticle,
  manOfflineArticle,
  listContentBusinessForUserMan,
  manSaveUserConfig,
  manListUserConfig,
} from "@/api/man";
import {
  jdh_qz_man_post_page,
  jdh_qz_man_query_post_featured,
} from "../../../../../api/community";
import { jdh_qz_man_post_top } from "../../../../../api/community";
import { jdh_qz_man_add_post_top } from "../../../../../api/community";
import { jdh_qz_man_add_post_featured } from "../../../../../api/community";
import { jdh_qz_man_cancel_post_top } from "../../../../../api/community";
import { jdh_qz_man_cancel_post_featured } from "../../../../../api/community";
import { jdh_qz_man_post_batch_audit } from "../../../../../api/community";
import modal from "@/components/modal";
import baseDialog from "../../../components/baseDialog";
import { getDiseasesData } from "../distribution";
import { request } from "@/utils/axios";
import {
  getDistributionScope,
  searchDataProcessing,
  getContentQuailty,
  getGeneralLabel,
  getContentSources,
} from "../distribution";
import {
  manListContentIndexTree,
  qzManPage,
  changeCommunity,
  jdh_community_list,
} from "@/api/indexs";
import { mapState } from "vuex";
import uploadImage from "@/components/uploadImage";
import uploadPosterImage from "@/components/upload/uploadPosterImage";
import uploadImgUniversal from "@/components/upload/uploadImgUniversal";
import GenericNameLabel from "@/components/combination/GenericNameLabel";
import UploadVideo from "@/components/combination/UploadVideo";
import { MessageBox, Message } from "element-ui";
import { getBusinessId } from "../../../../../utils/enum";

var selectList_bak = {
  articleId: "", //文章ID
  articleKeyWord: "", // 文章关键字
  diseaseLabel: "", // 疾病圈标签
  nickname: "", // 写手昵称
  writerPin: "", // 写手Pin
  doctorName: "", // 医生名字
  hospital: "", // 医院名称
  department: "", // 科室名称
  articleType: "", // 文章类型
  submissionTime: [], // 投稿时间
  auditTime: [], //
  featuredArticle: "", // 精选文章
  isOriginal: "", // 是否原创
  isTop: "", // 是否置顶
  business: [], // 所属业务
  categoryId: "", // 所属栏目
  channelId: "", // 所属频道
  categoryRelationId: "", // 类目ID
  range: "", // 分发范围
  quality: "", // 内容质量
  contentDiseasesNotNull: "",
  isDoctor: "",
  contentIndexIds: [], // 索引
  questionSource: null, // 问题来源
  videoType: "",
  videoDuration: {
    startNum: "",
    endNum: "",
  }, // 视频时长
  videoText: {
    startNum: "",
    endNum: "",
  }, // 视频正文
};
export default {
  name: "goTopManage",
  data() {
    return {
      num: 3,
      rejectForm: {
        rejectlineDialog: false,
        rejectReasons: "",
        applyReason: "",
        isShowBtn: [true, true], //弹窗是否能显示按钮
        ordinaryBtnText: ["取消", "确认"],
      },
      activeName: "all",
      selectedRows: [],
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: "帖子ID",
            prop: "postId",
            width: "180px",
          },
          {
            label: "帖子名称",
            prop: "title",
            width: "200px",
          },
          {
            label: "帖子正文",
            prop: "content",
            width: "250px",
          },
          {
            label: "所属圈子",
            prop: "communityName",
          },
          {
            label: "权重",
            prop:
              this.$route.query.tenantid == 484 ||
              this.$route.query.tenantid == 492
                ? "featuredTopSort"
                : this.$route.query.tenantid == 290 ||
                  this.$route.query.tenantid == 287
                ? "appFeaturedRankNum"
                : "appFeaturedRankNum",
            width: "150px",
          },
          {
            label: "发布者",
            prop: "nickName",
          },
          {
            label: "发布者id",
            prop: "pin",
          },
          {
            label: "帖子状态",
            prop: "auditStatusCheck",
          },
          {
            label: "发布时间",
            prop: "submitTime",
          },
        ],
        tableType: 222,
      },
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20],
      },
      articleStatus: [],
      articleListCode: 0,
      allCount: 0, // 全部
      offlineCount: 0, // 已下线
      offlineUnAuditCount: 0, // 下线待审核
      passAuditCount: 0, // 已通过
      rejectCount: 0, // 驳回
      unAuditCount: 0, // 待审核
      isShowBtn: [true, true, false],
      reviewOfflineDialog: false, // 审核下线申请
      btnText: ["驳回", "通过"],
      targetValue: null,
      isSelected: false,
      formData: {
        formList: {
          title: "下线文章",
          infoKey: "下线理由",
          infoValue: "",
          placeholder: "请输入下线理由",
          maxlength: "200",
          type: 2, //0(13\16) or 1(28)
        },
      },
      offlineDialogShow: false,
      formlist: [],
      selectList: this.$commonJs.deepClone(selectList_bak),
      reasonFrom: {
        seeReasonDialog: false,
        ordinaryBtnText: ["取消", "确认"],
        isShowBtn: [true, true], //弹窗是否能显示按钮
        reason: "",
      },
      old: {},
      isBtn: 1,
      isShowFilter: 1,
      searchFilterList: [],
      configId: null,
      checkList: [1000],
      allSearchList: [],
      serverList: [],
      contentAttributes: [],
      rangeList: [], // 分发范围
      qualityList: [], // 内容质量
      businessList: [],
      articleLabels: [], // 内容标签
      businessChannelArr: [],
      select: [
        {
          prop: "communityName",
          type: "input2",
          placeholder: "请输入圈子名称",
          maxLenth: 18,
        },
        {
          prop: "communityId",
          type: "input2",
          placeholder: "请输入圈子ID",
          maxLenth: 18,
        },
        {
          prop: "communityType",
          type: "input2",
          placeholder: "请输入圈子类型",
          maxLenth: 18,
        },
        // todo
        {
          prop: "articleId",
          type: "input2",
          placeholder: "请输入运营标签",
          maxLenth: 18,
        },
      ],
      select1: [
        {
          prop: "articleId",
          type: "input2",
          placeholder: "请输入文章ID进行检索",
          maxLenth: 18,
        },
        {
          prop: "articleKeyWord",
          type: "input",
          placeholder: "请输入标题关键词检索",
          maxLenth: 50,
        },
        {
          prop: "diseaseLabel",
          type: "disease",
          placeholder: "请输入疾病圈",
          List: [],
        },
        {
          prop: "nickname",
          type: "input",
          placeholder: "请输入写手昵称进行检索",
          maxLenth: 50,
        },
        {
          prop: "writerPin",
          type: "input",
          placeholder: "请输入写手Pin进行检索",
          maxLenth: 50,
        },
        {
          prop: "doctorName",
          type: "input",
          placeholder: "请输入医生姓名进行检索",
          maxLenth: 50,
        },
        {
          prop: "hospital",
          type: "input",
          placeholder: "请输入医院名称进行检索",
          maxLenth: 50,
        },
        {
          prop: "department",
          type: "input",
          placeholder: "请输入科室名称进行检索",
          maxLenth: 50,
        },
        {
          prop: "articleType",
          type: "select",
          placeholder: "请选择文章类型检索",
          List: [
            {
              value: 1,
              label: "图文",
            },
            {
              value: 7,
              label: "视频",
            },
          ],
        },
        {
          prop: "submissionTime",
          type: "picker",
          placeholder: "请选择投稿时间",
          //   List:[]
        },
        {
          prop: "featuredArticle",
          type: "select",
          placeholder: "是否精选",
          List: [
            {
              value: 2,
              label: "是",
            },
            {
              value: 1,
              label: "否",
            },
          ],
        },
        {
          prop: "isOriginal",
          type: "select",
          placeholder: "是否原创",
          List: [
            {
              value: 1,
              label: "是",
            },
            {
              value: 2,
              label: "否",
            },
          ],
        },
        {
          prop: "isTop",
          type: "select",
          placeholder: "是否置顶",
          List: [
            {
              value: 0,
              label: "全部",
            },
            {
              value: 1,
              label: "置顶",
            },
          ],
        },
        {
          prop: "business",
          type: "select",
          placeholder: "请输入所属业务",
          List: [],
        },
        {
          prop: "categoryId",
          type: "select",
          placeholder: "请输入所属栏目",
          List: [],
        },
        {
          prop: "channelId",
          type: "select",
          placeholder: "请输入所属频道",
          List: [],
        },
        {
          prop: "categoryRelationId",
          type: "input",
          placeholder: "请输入类目ID进行检索",
          maxLenth: 50,
        },
        {
          prop: "keyWords",
          type: "input",
          placeholder: "请输入全文关键词检索",
          maxLenth: 50,
        },
        {
          prop: "contentIndexIds",
          type: "selectIndex",
          placeholder: "请选择索引",
          List: [],
        },
      ],
      isButton: false,
      uploadShow: false,
      timer: null,
      //类目导入失败
      isImportErrorShow: false,
      failImportUrl: "",
      // 商品倒入失败
      isSaleImportErrorShow: false,
      failImportSaleUrl: "",
      //类目导出失败
      isExportErrorShow: false,
      failExportUrl: "",
      //商品导出失败
      isSaleExportErrorShow: false,
      failExportSaleUrl: "",
      // 导出文章失败
      isExportArticleShow: false,
      failExportArticleUrl: "",
      // ------------------- 批量导入 start ---------------------
      // 导入视频弹出是否显示标识
      dialogInVideoVisible: false,
      // 导出商品弹出是否显示标识
      dialogOutContentSkusVisibleSku: false,
      // 导入商品弹出是否显示标识
      dialogInContentSkusVisible: false,
      // 导入类目弹出是否显示标识
      dialogInCategoryVisible: false,
      // 导出类目弹出是否显示标识
      dialogOutCategoryVisible: false,
      // 批量上传
      fileList: [],
      dialogContentVisible: false,
      // 新建圈子
      dialogSetCircle: false,
      // 增加主视频
      dialogAddVideo: false,
      // ------------------- 批量导入 end ---------------------
      murl: "",
      videoImportExportCode: 14,
      importList: [
        {
          value: "1",
          label: "批量导入商品",
        },
        {
          value: "2",
          label: "批量导入类目",
        },
      ], // 导入列表
      importType: "", // 选中的导入选项
      exportList: [
        {
          value: "1",
          label: "批量导出商品",
        },
        {
          value: "2",
          label: "批量导出类目",
        },
      ],
      contentType: "1",
      questionFrom: [], // 记录内容来源
      circleForm: {
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        title: "",
        hotValue: "",
        content: "",
        communityType: "",
        pin: "",
        contentPicUrlList: [],
        contentPicUrl: "",
        isTopicTop: "",
        communityName: "",
        communityId: "",
        class: "",
        avatarUrl: "",
        nickName: "",
        auditor: "",
        updateUser: "",
        updateTime: "",
        postId: "",
        submitTime: "",
        isCommunityTop: "",
        auditTime: "",
        createTime: "",
        tenantId: parseInt(this.$route.query.tenantid),
        authorIp: "",
        auditStatus: "",
        createUser: "",
        isAutoAudit: "",
        status: "",
        realyName: "",
      },
      circleRules: {
        // name: [
        //   { required: true, message: '请输入圈子名称', trigger: 'blur' }
        // ],
        // imageUrl: [
        //   { required: true, message: '请上传圈子小图', trigger: 'change' }
        // ],
        // type: [
        //   { required: true, message: '请选择圈子类型', trigger: 'change' }
        // ],
        // features: [
        //   { required: true, type: 'array', min: 1, message: '请选择至少一个功能', trigger: 'change' }
        // ]
      },
      additionalFeatures: ["视频", "圈子", "问医生", "推荐好物"],
      circlePlaceholders: {
        视频: "请输入关键词，多个关键词‘;‘隔开",
        问医生: "请输入医生搜索关键词",
        推荐好物: "请输入商品搜索关键词",
      },
      titlePicUrl: [],
      dialogVisible: false,
      searchParams: {
        communityName: "",
        communityIds: this.$route.query.circleId || "",
        communityType: "",
        auditStatus: "",
      },
      showMultiSelect: false,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src: "", // url地址
          },
        ],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
      communityOptions: [],
    };
  },
  components: {
    // search,
    manFormList,
    breadCrumb,
    circleTable,
    pagination,
    modal,
    baseDialog,
    uploadPosterImage,
    uploadImage,
    uploadImgUniversal,
    GenericNameLabel,
    UploadVideo,
  },
  async created() {
    // console.log('开始=========》');
    // 查询用户保存配置
    await this.queryUserConfig();
    //  获取天空之城数据
    await this.queryFloorList();
    //  console.log('结束=========》');
    // 获取分发范围
    this.getDistributionScope();
    // 获取内容质量
    this.getContentQuailty();
    // 是否由文章详情页跳转本页面
    this.initializeJump();
    // sessionStorage获取tabpane的状态
    this.getSessionStorageInfo();
    // this.getArticleList()
    this.listContentBusinessForUserMan();
    // 获取标签
    this.getGeneralLabel();
    this.getIndexTreeList();
    // 获取圈子select
    this.getCommunitySelect();
    getContentSources(this);
    // this.communityList();
    if (this.$route.query.circleId) {
      const circleId = this.$route.query.circleId;
      this.handleInitSearch(circleId);
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 添加这段代码
      const $el = document.querySelectorAll(
        ".el-cascader-panel .el-cascader-node[aria-owns]"
      );
      Array.from($el).map((item) => item.removeAttribute("aria-owns"));
    });
  },
  destroyed() {
    // 销毁详情跳跳转存储
    sessionStorage.removeItem("content");
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  computed: {
    ...mapState(["imgHost", "userInfo"]),
  },
  methods: {
    recursionObj(node, callback, judge) {
      if (judge(node)) {
        node = callback(node);
      }
      if (!node.contentIndexes || node.contentIndexes.length === 0) {
        return;
      }
      for (let i = 0; i < node.contentIndexes.length; i++) {
        if (judge(node)) {
          this.recursionObj(node.contentIndexes[i], callback, () => true);
        } else {
          this.recursionObj(node.contentIndexes[i], callback, judge);
        }
      }
      return;
    },
    importChangeFn(v) {
      console.log("importChangeFn", v);
      if (v == 1) {
        this.dialogInContentSkusVisible = true;
      } else if (v == 2) {
        this.dialogInCategoryVisible = true;
      }
    },
    exportChangeFn(v) {
      console.log("exportChangeFn", v);
      if (v == 1) {
        this.dialogOutContentSkusVisibleSku = true;
      } else if (v == 2) {
        this.dialogOutCategoryVisible = true;
      } else if (v == 3) {
        this.downloadDiles(8);
      } else if (v == 4) {
        this.downloadDiles(7);
      } else if (v == 5) {
        this.downloadDiles(5);
      } else if (v == 6) {
        this.downloadDiles(4);
      } else if (v == 7) {
        this.downloadDiles(2);
      }
    },
    // 获取索引下拉数据
    getIndexTreeList() {
      manListContentIndexTree().then((res) => {
        // 处理树的叶子结点
        for (let i = 0; i < res.length; i++) {
          this.recursionObj(
            res[i],
            (curNode) => {
              curNode.contentIndexes = undefined;
              return curNode;
            },
            (node) => node.contentIndexes.length === 0
          );
        }
        this.indexTreeList = res;
        this.select.map((subItem) => {
          if (subItem.prop == "contentIndexIds") {
            subItem.List = res;
          }
        });
      });
    },
    // 获取圈子select
    getCommunitySelect() {
      qzManPage({
        pageNo: 1,
        pageSize: 100, // 后端设定 夜迷不可能超过100 后期优化非分页
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        status: 1,
      }).then((res) => {
        console.log("qzManPage", res);
        this.communityOptions = (res.data || [])?.map((item) => ({
          value: item.communityId,
          label: item.communityName,
        }));
        console.log("getCommunitySelect", res);
      });
    },
    remoteMethod(query) {
      console.log("==== query quanziList", query);
      qzManPage({
        pageNo: 1,
        pageSize: 100, // 后端设定 夜迷不可能超过100 后期优化非分页
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        status: 1,
        communityName: query,
      }).then((res) => {
        console.log("query quanziList", res);
        this.communityOptions = (res.data || [])?.map((item) => ({
          value: item.communityId,
          label: item.communityName,
        }));
        console.log("getCommunitySelect", res);
      });
    },
    onClearSelect() {
      console.log("==== onClear");
      qzManPage({
        pageNo: 1,
        pageSize: 100, // 后端设定 夜迷不可能超过100 后期优化非分页
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        status: 1,
      }).then((res) => {
        console.log("reset", res);
        this.communityOptions = (res.data || [])?.map((item) => ({
          value: item.communityId,
          label: item.communityName,
        }));
      });
    },
    communityOptionsShow(show) {
      this.communityOptionsVisible = show;
    },
    communityOptionsConfirm() {
      console.log(this.circleForm);
      if (!this.communityOptionsValue) {
        this.$message({
          message: "请选择所属圈子",
          type: "warning",
        });
        return;
      }
      this.communityOptionsloading = true;
      try {
        changeCommunity({
          targetCommunityId: this.communityOptionsValue,
          postIds: [this.circleForm.postId],
          tenantId: parseInt(this.$route.query.tenantid),
          businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        })
          .then((res) => {
            console.log(res);
            if (res) {
              this.communityOptions.map((item) => {
                console.log(item);
                if (item.value === this.communityOptionsValue) {
                  this.circleForm.communityName = item.label;
                }
              });
              this.communityOptionsVisible = false;
              this.getArticleList();
            } else {
              this.$message({
                message: "失败",
                type: "error",
              });
            }
          })
          .catch((err) => {
            console.log("err", err);
            this.$message({
              message: err.msg || "失败",
              type: "error",
            });
          });
        this.communityOptionsloading = false;
      } catch (err) {
        console.log("err", err);
        this.$message({
          message: "失败",
          type: "error",
        });
        this.communityOptionsloading = false;
      }
    },
    // 上传弹窗关闭
    closeDialog() {
      let fileVal = this.$refs.file;
      fileVal.value = "";
      this.fileResult = "";
      this.fileName = "";
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    // 查询疾病圈库名称
    getDiseases(val) {
      getDiseasesData(val, this);
    },
    // 回到列表页 跳转
    initializeJump() {
      if (sessionStorage.getItem("content")) {
        this.paginationDataProduct.currentPage =
          sessionStorage.getItem("currentPage");
        this.selectList = JSON.parse(sessionStorage.getItem("select"));
        this.select = JSON.parse(sessionStorage.getItem("selectList"));
      } else {
        this.paginationDataProduct.currentPage = 1;
        this.selectList = selectList_bak;
        this.isSelected = false;
        //  改版注掉
        // this.select[14].List = []
        // this.select[15].List = []
        this.selectList = this.$commonJs.deepClone(selectList_bak); // 清空
      }
    },
    // 跳转存储信息
    setStorage() {
      // 跳转页面存储当前页码
      sessionStorage.setItem(
        "currentPage",
        this.paginationDataProduct.currentPage
      );
      sessionStorage.setItem("activeName", this.activeName);
      let selectStr = JSON.stringify(this.selectList);
      let selectList = JSON.stringify(this.select);
      sessionStorage.setItem("selectList", selectList);
      sessionStorage.setItem("select", selectStr);
    },
    getSessionStorageInfo() {
      this.activeName = sessionStorage.getItem("activeName") || "all";
      if (this.activeName === "all") {
        this.articleListCode = 0;
        this.searchParams.auditStatusCheck = "";
      } else if (this.activeName === "pending") {
        this.articleListCode = 2;
        this.searchParams.auditStatusCheck = 0;
      } else if (this.activeName === "passed") {
        this.articleListCode = 3;
        this.searchParams.auditStatusCheck = 1;
      } else if (this.activeName === "offline") {
        this.articleListCode = 5;
        this.searchParams.auditStatusCheck = 2;
      }
      this.articleStatus = [];
      if (this.articleListCode !== 0) {
        this.articleStatus.push(this.articleListCode);
      }
      this.getArticleList();
    },
    // 切换tab
    handleClick(tab, event) {
      sessionStorage.setItem("activeName", tab.name);
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };
      // this.getArticleList()
      if (this.activeName === "all") {
        this.articleListCode = 0;
        this.searchParams.auditStatusCheck = "";
      } else if (this.activeName === "pending") {
        this.articleListCode = 1;
        this.searchParams.auditStatusCheck = 0;
      } else if (this.activeName === "passed") {
        this.articleListCode = 2;
        this.searchParams.auditStatusCheck = 1;
      } else if (this.activeName === "offline") {
        this.articleListCode = 3;
        this.searchParams.auditStatusCheck = 2;
      }
      this.articleStatus = [];
      if (this.articleListCode !== 0) {
        this.articleStatus.push(this.articleListCode);
      }
      this.getArticleList();
    },
    // 操作逻辑
    async TabhandleClick(val) {
      if (val.type === "edit") {
        this.setStorage();
        // 跳转到文章编辑页面
        // this.$router.push({
        //   path: `/contentAudit/contentedit`,
        //   query: {
        //     id: val.val.id,
        //     actionType: 1,
        //     articleType: val.val.articleType,
        //     requestSource: 1,
        //     labelGroupId: this.$route.query.labelGroupId || undefined,
        //   }
        // })
        // 打开编辑弹窗
        this.dialogSetCircle = true;
        // this.circleForm = { "name": "测试", "imageUrl": "/jfs/t1/237264/27/22820/1206/6697be78F55023f84/77a25cf7e6405a34.jpg", "type": "A", "category": "111", "tags": "兴趣圈", "isHot": "是", "features": [ "视频", "圈子", "问医生", "推荐好物" ], "featureInputs": { "视频": "1111;2222", "问医生": "医生医生", "推荐好物": "好物好物" } }
        // this.circleForm =  this.tableData.tableList[1]
      } else if (val.type === "check") {
        this.setStorage();
        // 跳转到文章编辑页面
        // this.$router.push({
        //   path: `/contentAudit/contentedit`,
        //   query: {
        //     id: val.val.id,
        //     labelGroupId: this.$route.query.labelGroupId || undefined,
        //     requestSource: 2
        //   }
        // })
        // mock
        // this.circleForm = {...this.circleForm,
        //   PostExtDTO:{
        //     sensitiveWordInfo : '11111',
        //     isImageSensitiveWord : true,
        //     isImagePorn : true
        //   }
        // }
        console.log("========", val.val);
        this.circleForm = val.val;
        this.dialogSetCircle = true;
        // this.circleForm.communityPicUrl = url.replace(imgHost, "");
      } else if (val.type === "postpass") {
        // 审核通过
        // val.val.badge === 1 ? this.setArticleBadgeStatus(2, val.val.id) : this.setArticleBadgeStatus(1, val.val.id);
        this.confirmSinglePass(val.val.postId);

        // this.getArticleList()
      } else if (val.type === "postdeny") {
        // 审核拒绝
        this.confirmSingleDeny(val.val.postId);
      } else if (val.type === "posttop") {
        // 置顶
        jdh_qz_man_post_top({
          postId: val.val.postId,
          businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
          tenantId: parseInt(this.$route.query.tenantid),
        }).then(() => {
          this.getArticleList();
        });
      }
      this.getTargetValue(val.val);
      this.getArticleList();
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.$refs?.table?.concelEditSort?.();
      this.getArticleList("pageChange");
    },
    // 设置精选
    setArticleBadgeStatus(badge, id) {
      setArticleBadgeStatus({
        tenantId: this.$commonJs.getTenantId(),
        id: id,
        badge: badge,
      }).then((res) => {
        this.getArticleList();
      });
    },
    // 导出请求参数方法
    exFormData() {
      if (this.selectList.range != "" || this.selectList.quality != "") {
        this.searchDataProcessing();
      }
      let arr = [];
      if (this.selectList.articleLabel) {
        this.selectList.articleLabel.map((item) => {
          arr.push(item[item.length - 1]);
        });
      }
      // debugger
      let searchArticleTypes = [];
      //bugfix:文章类型必须是数组 否则接口报错
      console.log(this.selectList.actionType);
      this.selectList.articleType && this.selectList.articleType != "全部"
        ? searchArticleTypes.push(this.selectList.articleType)
        : "";
      const contentIndexIds =
        this.selectList?.contentIndexIds?.map(
          (item) => item[item?.length - 1]
        ) || [];
      let parameter = {
        tenantId: this.$commonJs.getTenantId(),
        id: this.selectList.articleId || null,
        title: this.selectList.articleKeyWord || null,
        keyWords: this.selectList.keyWords || null,
        diseaseIds: this.selectList.diseaseLabel
          ? [this.selectList.diseaseLabel]
          : [],
        nickName: this.selectList.nickname || null, //bugfix: nickname 字段取了大写
        originalAuthorName: this.selectList.doctorName || null,
        userPin: this.selectList.writerPin || null,
        originalAuthorUnit: this.selectList.hospital || null,
        originalAuthorDepart: this.selectList.department || null,
        articleTypes: searchArticleTypes || null,
        startSubmitTime:
          (this.selectList.submissionTime &&
            this.selectList.submissionTime[0]) ||
          null,
        endSubmitTime:
          (this.selectList.submissionTime &&
            this.selectList.submissionTime[1]) ||
          null,
        startAuditTime:
          (this.selectList.auditTime && this.selectList.auditTime[0]) || null,
        endAuditTime:
          (this.selectList.auditTime && this.selectList.auditTime[1]) || null,
        contentAttributes: this.contentAttributes || [], // 内容属性
        contentLabelIds: arr || [],
        badge:
          this.selectList.featuredArticle &&
          this.selectList.featuredArticle != "全部"
            ? this.selectList.featuredArticle
            : null,
        articleSource:
          this.selectList.isOriginal && this.selectList.isOriginal != "全部"
            ? this.selectList.isOriginal
            : null,
        page: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        articleStatus: this.articleStatus,
        isTop: this.selectList.isTop == 0 ? "" : 1 || null,
        businessIds:
          typeof this.selectList.business == "number"
            ? [this.selectList.business]
            : this.selectList.business || [],
        contentCategoryIds:
          typeof this.selectList.categoryId == "number"
            ? [this.selectList.categoryId]
            : this.selectList.categoryId || [],
        contentChannelIds:
          typeof this.selectList.channelId == "number"
            ? [this.selectList.channelId]
            : this.selectList.channelId || [],
        categoryRelationIds: this.selectList.categoryRelationId
          ? [this.selectList.categoryRelationId]
          : [],
        auditUser: this.selectList.auditUser || null,
        contentDiseasesNotNull:
          this.selectList.contentDiseasesNotNull &&
          this.selectList.contentDiseasesNotNull != "全部"
            ? this.selectList.contentDiseasesNotNull
            : null,
        isDoctor:
          this.selectList.isDoctor && this.selectList.isDoctor != "全部"
            ? this.selectList.isDoctor
            : null,
        contentIndexIds,
      };
      return parameter;
    },
    //获取文章列表
    getArticleList(type) {
      console.log(this.selectList, "pppppppppppp");
      if (this.selectList.range != "" || this.selectList.quality != "") {
        this.searchDataProcessing();
      }
      let arr = [];
      if (this.selectList.articleLabel) {
        this.selectList.articleLabel.map((item) => {
          arr.push(item[item.length - 1]);
        });
      }
      console.log(
        this.selectList.videoText.startNum,
        "videoTextStartNum",
        this.selectList.videoText,
        this.selectList.videoDuration
      );
      // debugger
      let searchArticleTypes = [];
      //bugfix:文章类型必须是数组 否则接口报错
      console.log(this.selectList.actionType);
      this.selectList.articleType && this.selectList.articleType != "全部"
        ? searchArticleTypes.push(this.selectList.articleType)
        : "";
      const contentIndexIds =
        this.selectList?.contentIndexIds?.map(
          (item) => item[item?.length - 1]
        ) || [];
      // 人工干预 - 精选池请求列表
      if (
        this.$route.query.tenantid == 484 ||
        this.$route.query.tenantid == 492
      ) {
        let params = {
          // tenantId: this.$commonJs.getTenantId(),
          tenantId: parseInt(this.$route.query.tenantid),
          pageNo: this.paginationDataProduct.currentPage,
          pageSize: this.paginationDataProduct.pageSize,
          businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
          title: this.searchParams.title,
          auditStatus: "",
          postIds: this.searchParams.postIds,
          communityIds: this.searchParams.communityIds,
          titleSearchKeyword: this.searchParams.titleSearchKeyword,
          contentSearchKeyword: this.searchParams.contentSearchKeyword,
          // beginTime: utils.isEmpty(this.searchParams.contributeTime) ? null : utils.timetamp(Number(this.searchParams.contributeTime[0])), // 开始时间
          // endTime: utils.isEmpty(this.searchParams.contributeTime) ? null : utils.timetamp(Number(this.searchParams.contributeTime[1])), // 结束时间
          authorPin: this.searchParams.authorPin,
          preSetTop: 1,
          status: 1,
        };
        jdh_qz_man_post_page(params).then((res) => {
          this.tableData.tableList.splice(0, this.tableData.tableList.length);
          res.data.map((item) => {
            item.submitTime = this.formatDate(item.submitTime);
            if (item.auditStatus == 0) {
              item.auditStatusCheck = "待审核";
            } else if (item.auditStatus == 1) {
              item.auditStatusCheck = "审核通过";
            } else if (item.auditStatus == 2) {
              item.auditStatusCheck = "审核拒绝";
            }
            this.tableData.tableList.push(item);
          });
          this.paginationDataProduct.total = res.totalCount;
          this.paginationDataProduct.currentPage = res.pageNo;
          this.paginationDataProduct.pageSize = res.pageSize;
          if (type != "pageChange" && this.isSelected) {
            this.isSelected = false;
          }
          console.log(
            "???",
            res.data,
            this.tableData,
            this.tableData.tableList[1]
          );
        });
      } else if (
        this.$route.query.tenantid == 287 ||
        this.$route.query.tenantid == 290
      ) {
        let params = {
          tenantId: parseInt(this.$route.query.tenantid),
          businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
          pageNo: this.paginationDataProduct.currentPage,
          pageSize: this.paginationDataProduct.pageSize,
          // communityId:this.searchParams.communityId,
          title: this.searchParams.title,
          auditStatus: "",
          postId: this.searchParams.postIds,
          communityIds: this.searchParams.communityIds,
          titleSearchKeyword: this.searchParams.titleSearchKeyword,
          contentSearchKeyword: this.searchParams.contentSearchKeyword,
          // beginTime: utils.isEmpty(this.searchParams.contributeTime) ? null : utils.timetamp(Number(this.searchParams.contributeTime[0])), // 开始时间
          // endTime: utils.isEmpty(this.searchParams.contributeTime) ? null : utils.timetamp(Number(this.searchParams.contributeTime[1])), // 结束时间
          authorPin: this.searchParams.authorPin,
          status: 1,
        };
        jdh_qz_man_query_post_featured(params)
          .then((res) => {
            this.tableData.tableList.splice(0, this.tableData.tableList.length);
            res.data.map((item) => {
              item.submitTime = this.formatDate(item.submitTime);
              if (item.auditStatus == 0) {
                item.auditStatusCheck = "待审核";
              } else if (item.auditStatus == 1) {
                item.auditStatusCheck = "审核通过";
              } else if (item.auditStatus == 2) {
                item.auditStatusCheck = "审核拒绝";
              }
              this.tableData.tableList.push(item);
            });
            this.paginationDataProduct.total = res.totalCount;
            this.paginationDataProduct.currentPage = res.pageNo;
            this.paginationDataProduct.pageSize = res.pageSize;
            if (type != "pageChange" && this.isSelected) {
              this.isSelected = false;
            }
            console.log(
              "???",
              res.data,
              this.tableData,
              this.tableData.tableList[1]
            );
          })
          .catch((err) => {
            this.$message.error(err.msg);
          });
      }

      // // 获取各个审核状态的文章的数量
      // getAllArticleCounts(params).then(res => {
      //   this.allCount = res.allCount
      //   this.unAuditCount = res.unAuditCount
      //   this.passAuditCount = res.passAuditCount
      //   this.rejectCount = res.rejectCount
      //   this.offlineCount = res.offlineCount
      //   this.offlineUnAuditCount = res.offlineUnAuditCount
      // })
    },

    handleDialog(val) {
      this.reviewOfflineDialog = val;
    },
    getTargetValue(target) {
      this.targetValue = target;
    },
    reviewOffHandler(type) {
      if (type === "one") {
        this.reviewOfflineDialog = false;
        this.rejectForm.rejectlineDialog = true;
      } else if (type === "two") {
        //审核通过下线文章 --------------------- done
        passOfflineArticle({
          tenantId: this.$commonJs.getTenantId(),
          articleId: this.targetValue.id,
        })
          .then((res) => {
            this.reviewOfflineDialog = false;
            this.$message({
              message: "审核通过下线成功",
              type: "success",
            });
            this.getArticleList();
          })
          .catch((error) => {
            this.$message.error("审核通过未能成功下线");
          });
      }
    },
    offlineDialogHandel(data) {
      this.offlineDialogShow = data;
    },
    offlineCloseDialog(type) {
      // if(this.formData.formList.infoValue) {

      // } else {
      //   this.$message.error('请输入下线理由')
      // }
      if (type === "success") {
        // formData.formList.infoValue
        if (this.$utils.isEmpty(this.formData.formList.infoValue)) {
          return this.$message.error("请输入下线理由");
        } else {
          // 运营下线 --------------------done
          manOfflineArticle({
            tenantId: this.$commonJs.getTenantId(),
            articleId: this.targetValue.id,
            remark: this.formData.formList.infoValue,
          })
            .then((res) => {
              this.$message({
                message: "下线成功",
                type: "success",
              });
              this.offlineDialogShow = false;
              this.getArticleList();
              // window.location.reload(); // 刷新页面
            })
            .catch((error) => {
              this.$message.error("未能成功下线");
            });
        }
      } else {
        this.offlineDialogShow = false;
      }
    },
    //查询当前运营所有的业务
    listContentBusinessForUserMan() {
      listContentBusinessForUserMan({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        res?.contentBusinesses?.forEach((item) => {
          // 改版注掉f
          // this.select[13].List.push({
          //   label: item.name,
          //   value: item.id
          // })
          this.businessList.push({
            label: item.name,
            value: item.id,
          });
          this.select.map((subItem) => {
            if (subItem.prop == "business" && subItem.cfgID == 4000) {
              subItem.List.push({
                label: item.name,
                value: item.id,
              });
            }
            return subItem;
          });
        });
      });
    },
    getGeneralLabel() {
      getGeneralLabel(this);
    },
    // 清空筛选
    empty(data) {
      this.selectList = selectList_bak;
      this.isSelected = false;
      Object.keys(this.selectList).map((item) => {
        console.log("item=++++++++++++++++++++++++++++++++++", item);
        if (["videoDuration", "videoText"].includes(item)) {
          this.selectList[item] = {};
        } else if (item === "contentIndexIds") {
          this.selectList[item] = [];
        } else {
          this.selectList[item] = "";
        }
      });
      // this.select[14].List = []
      // this.select[15].List = []
      this.contentAttributes = [];
      this.selectList = this.$commonJs.deepClone(selectList_bak); // 清空
      this.getArticleList(); //bugfix:清空后没有分页请求数据 造成清空后 页面没有变化
      console.log(this.selectList, "ppppppp--------->");
    },
    // 过滤
    searchFilter() {},
    // 配置项勾选
    checkBoxedChange(value) {},
    // 点击
    clickSingleBoxed(checked, item) {
      console.log("clickSingleBoxed======>22222", checked, item);
      if (checked) {
        // 添加
        if (item.cfgID == 4000) {
          this.businessChannelArr.map((busItem) => {
            this.configSubItem(busItem);
            this.select.push(busItem);
          });
          this.checkList.push(item.cfgID);
        } else {
          this.checkList.push(item.cfgID);
          this.configSubItem(item);
          this.select.push(item);
        }
      } else {
        // 删除
        this.checkList = this.checkList.filter((value) => {
          if (value == item.cfgID) return false;
          return true;
        });
        if (item.cfgID == 4000) {
          this.businessChannelArr.map((busItem) => {
            busItem.List = [];
            this.selectList[busItem.prop] = "";
          });
        } else {
          this.selectList[item.prop] = "";
        }
        this.select = this.select.filter((value) => {
          if (value.cfgID == item.cfgID) return false;
          return true;
        });
      }
    },
    configSubItem(subItem) {
      if (subItem.cfgID == 3004) {
        let arr = this.qualityList.map((item) => {
          return { value: item.id, label: item.desc };
        });
        subItem.List = arr;
      }
      if (subItem.cfgID == 3003) {
        let arr = this.rangeList.map((item) => {
          return { value: item.id, label: item.desc };
        });
        subItem.List = arr;
      }
      if (subItem.cfgID == 4000 && subItem.prop == "business") {
        subItem.List = this.businessList;
      }
      if (subItem.cfgID == 4001) {
        subItem.List = this.articleLabels;
      }
      if (subItem.cfgID == 4002) {
        subItem.List = this.indexTreeList;
      }
      if (subItem.cfgID == 5004) {
        subItem.List = this.questionFrom;
        // this.selectList[subItem.prop] = ['全部', ...this.questionFrom.map(subItem => subItem.value)];
      }
    },
    // 配置项隐藏
    popHide(value) {
      console.log(value, "contentAudit--popHide");
      this.saveUserConfig({
        configId: this.configId,
        tenantId: this.$commonJs.getTenantId(),
        configCode: "1",
        sceneCode: "1",
        value: value.toString(),
      });
    },
    // 获取天空之城数据 生成页面数据
    async queryFloorList() {
      // console.log('queryFloorList=======>', 33333);
      await request("jdh_laputa_queryFloorList", {
        functionId: "contentReviewOnOffLine",
        appId: "21557c5d3d0a4ec1b0184719022bb4b5",
        osName: "jdhwiki",
        venderId: null,
        inquiryTenancyId: null,
        version: 5,
      })
        .then(async (res) => {
          // this.floorTransferDTOS = res?.cf?.floorTransferDTOS;
          // console.log(res?.cf?.floorTransferDTOS[0], 'contentAudit<----来了哥----->');
          //  处理天空之城数据
          const cfgArray = res?.cf?.floorTransferDTOS[0].cfgList.filter(
            (item) => {
              if (item?.name == "manuDataCfg" && item?.checkbox == "common") {
                return true;
              }
              return false;
            }
          );
          // console.log(cfgArray, 'contentAudit<----来了哥----->cfgArray');
          // 整体配置数据
          let valueArray = JSON.parse(cfgArray[0].value).map((item) => {
            return JSON.parse(item?.value);
          });
          let fileterArray = [];
          let allShowSearchArr = [];
          // 所有配置的数据 包括 ids
          valueArray.map((item) => {
            let filerItem = this.$commonJs.deepClone(item);
            if (!Array.isArray(filerItem?.selectedIDs)) {
              // 获取搜索筛选总的展示
              filerItem.selectItems = filerItem?.selectItems.filter(
                (subItem) => {
                  return subItem.isShow;
                }
              );
              fileterArray.push(filerItem);

              item.selectItems = item?.selectItems.map((subItem) => {
                if (subItem.cfgID == 4000) {
                  this.businessChannelArr.push(subItem);
                }
                return subItem;
              });
              allShowSearchArr.push(item);
            } else {
              if (this.serverList?.length == 0) {
                // console.log('默认id', 'itemSelectedIDs========>');
                this.checkList = item?.selectedIDs;
              }
            }
          });

          // console.log(valueArray ,fileterArray, 'valueArray=====>|||||allShowSearchArr',allShowSearchArr);
          this.allSearchList = allShowSearchArr;
          // 搜索筛选弹框展示的数据
          this.searchFilterList = fileterArray;
          // console.log(valueArray, '拿到我配置的数据');

          // 页面上展示搜索
          let tempSelectList = [];
          this.checkList?.map((cItem) => {
            allShowSearchArr.map((item) => {
              item?.selectItems?.map((subItem) => {
                if (cItem == subItem.cfgID) {
                  tempSelectList.push(subItem);
                }
              });
            });
          });
          // 显示的搜索弹框
          this.select = tempSelectList;
          // console.log(res, 'queryFloorList=====>|||||');
        })
        .catch((err) => {
          this.$message.error(err.msg || "查询失败");
        });
      // console.log('queryFloorList=======>', 44444);
    },
    // 查询用户配置
    async queryUserConfig() {
      // console.log('queryUserConfig=======>', 11111);
      await manListUserConfig({
        tenantId: this.$commonJs.getTenantId(),
        configCode: "1",
        sceneCode: "1",
      }).then((res) => {
        if (res && res?.length > 0) {
          const userConfigBizDTO = res[0];
          this.configId = userConfigBizDTO?.configId;
          // console.log(this.configId,userConfigBizDTO, 'configId=====>',userConfigBizDTO?.value.split(','));
          this.checkList = userConfigBizDTO?.value
            .split(",")
            .map((item) => parseInt(item));
          this.serverList = userConfigBizDTO?.value
            .split(",")
            .map((item) => parseInt(item));
        }
        console.log("queryUserConfig=======>", res);
      });
      // console.log('queryUserConfig=======>', 222222);
    },
    // 用户保存配置
    async saveUserConfig(body) {
      await manSaveUserConfig(body).then((res) => {
        console.log(res, "用户保存了==========>");
      });
    },
    selectChenge(data) {
      this.isSelected = true;
      this.old = data;
    },
    //查询操作
    getChangeValue(data) {
      if (!this.$utils.checkNumber(this.selectList.articleId)) {
        return this.$message({
          message: "ID只能为数字类型",
          type: "warning",
        });
      }
      this.paginationDataProduct.currentPage = 1;
      // this.formlist=data //赋值操作
      this.getArticleList();
    },
    //驳回
    rejectClickHandler(arg) {
      if (arg === "two") {
        if (this.rejectForm.rejectReasons.length === 0) {
          this.$message.error("驳回理由不能为空");
        } else {
          rejectOfflineArticle({
            tenantId: this.$commonJs.getTenantId(),
            articleId: this.targetValue.id,
            remark: this.rejectForm.rejectReasons,
          })
            .then((res) => {
              this.$message({
                message: "成功驳回",
                type: "success",
              });
              this.getArticleList();
            })
            .catch((error) => {
              this.$message.error("驳回失败");
            });
        }
        this.rejectForm.rejectReasons = ""; //置空驳回原因
        this.rejectForm.rejectlineDialog = false;
      } else {
        this.rejectForm.rejectlineDialog = false;
        this.rejectForm.rejectReasons = ""; //置空驳回原因
      }
    },
    //查看理由
    viewReasonClick(arg) {
      this.reasonFrom.seeReasonDialog = false;
      this.reasonFrom.reason = "";
    },
    // 查询分发范围
    getDistributionScope() {
      getDistributionScope(this);
    },
    getContentQuailty() {
      getContentQuailty(this);
    },
    // 内容性质、文章级别、内容分发数据统一梳理方法
    dataTraversal(list, name) {
      list.map((item) => {
        if (item.id == name) {
          let arr = {};
          arr.code = item.code;
          arr.type = item.type;
          this.contentAttributes.push(arr);
        }
      });
    },
    // 搜索内容属性处理
    searchDataProcessing() {
      searchDataProcessing(this);
    },
    setCircle() {
      console.log("SETCIRCLE");
      this.dialogSetCircle = true;
    },
    changeTitlePic(data) {
      // data-封面组件的返回值
      this.titlePicUrl = data;
      // this.circleForm.imageUrl = data
      if (this.titlePicUrl && this.titlePicUrl.length > 0) {
        let url = this.titlePicUrl[0].url;
        // url 要截去的那部分 这个要从环境变量中取
        const imgHost = process.env.VUE_APP_imgHost;
        this.circleForm.imageUrl = url.replace(imgHost, "");
      } else {
        this.circleForm.imageUrl = "";
      }
    },
    updateSelectedRows(rows) {
      console.log("!!!!", rows);
      this.selectedRows = rows;
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const pad = (n) => n.toString().padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    auditStatusText(status) {
      switch (status) {
        case 0:
          return "待审核";
        case 1:
          return "审核通过";
        case 2:
          return "审核拒绝";
        default:
          return "未知状态";
      }
    },
    // handlePreview(file) {
    //   this.currentImageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    // handleRemove(file, fileList) {
    //   this.circleForm.imageUrl = fileList;
    // },
    // handleExceed(files, fileList) {
    //   this.$message.warning('最多只能上传 9 张图片');
    // },
    changeTitlePic(newImageUrl) {
      this.circleForm.imageUrl = newImageUrl;
    },
    deleteImage(index) {
      this.circleForm.imageUrl.splice(index, 1);
    },
    viewImage(url) {
      this.currentImageUrl = url;
      this.dialogVisible = true;
    },
    handleMultiAudit() {
      this.$refs.childTable.selectAllRows();
      this.showMultiSelect = true;
    },
    confirmMultiPass() {
      if (this.selectedRows && this.selectedRows.length !== 0) {
        MessageBox.confirm("确定要批量审核通过选中的帖子吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.handleMultiPass();
            this.$message.success("已批量审核");
          })
          .then(() => {
            this.getArticleList();
          })
          .catch(() => {
            this.$message("已取消批量审核");
          });
      } else {
        this.$message.error("请先选择帖子");
      }
    },
    confirmSinglePass(data) {
      MessageBox.confirm("确定要审核通过选中的帖子吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleSinglePass(data);
        })
        .then(() => {
          this.getArticleList();
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "已取消批量审核",
          });
        });
    },
    handleMultiPass() {
      // 初始化一个空数组 postIds 用于存储每个 post 的 postId
      const postIds = [];

      // 遍历 posts 数组，提取每个 post 的 postId 并放入 postIds 数组中
      this.selectedRows.forEach((post) => {
        postIds.push(post.postId);
      });

      // 创建一个包含 postIds 和 targetAuditStatus 的对象 params
      const params = {
        postIds: postIds,
        targetAuditStatus: 1,
        status: 1,
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        tenantId: parseInt(this.$route.query.tenantid),
      };

      jdh_qz_man_post_batch_audit(params)
        .then((res) => {
          this.$message({
            message: res ? "审核成功" : "审核失败",
            type: "success",
          });
        })
        .then(() => {
          this.getArticleList();
        });
    },
    handleSinglePass(data) {
      // 初始化一个空数组 postIds 用于存储每个 post 的 postId
      const postIds = [];
      postIds.push(data);

      // 创建一个包含 postIds 和 targetAuditStatus 的对象 params
      const params = {
        postIds: postIds,
        targetAuditStatus: 1,
        status: 1,
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        tenantId: parseInt(this.$route.query.tenantid),
      };

      jdh_qz_man_post_batch_audit(params)
        .then((res) => {
          this.$message({
            message: res ? "审核成功" : "审核失败",
            type: "success",
          });
        })
        .then(() => {
          this.dialogSetCircle = false;
          this.getArticleList();
        });
    },
    confirmMultDeny() {
      if (this.selectedRows && this.selectedRows.length !== 0) {
        MessageBox.confirm("确定要批量审核拒绝选中的帖子吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.handleMultiDeny();
          })
          .then(() => {
            this.getArticleList();
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "已取消批量审核",
            });
          });
      } else {
        this.$message.error("请先选择帖子");
      }
    },
    confirmSingleDeny(data) {
      MessageBox.confirm("确定要审核拒绝选中的帖子吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleSingleDeny(data);
        })
        .then(() => {
          this.dialogSetCircle = false;
          this.getArticleList();
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "已取消批量审核",
          });
        });
    },
    handleMultiDeny() {
      // 初始化一个空数组 postIds 用于存储每个 post 的 postId
      const postIds = [];

      // 遍历 posts 数组，提取每个 post 的 postId 并放入 postIds 数组中
      this.selectedRows.forEach((post) => {
        postIds.push(post.postId);
      });

      // 创建一个包含 postIds 和 targetAuditStatus 的对象 params
      const params = {
        postIds: postIds,
        targetAuditStatus: 2,
        status: 2,
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        tenantId: parseInt(this.$route.query.tenantid),
      };

      jdh_qz_man_post_batch_audit(params)
        .then((res) => {
          this.$message({
            message: res ? "审核成功" : "审核失败",
            type: "success",
          });
        })
        .then(() => {
          this.getArticleList();
        });
    },
    handleSingleDeny(data) {
      // 初始化一个空数组 postIds 用于存储每个 post 的 postId
      const postIds = [];

      postIds.push(data);

      // 创建一个包含 postIds 和 targetAuditStatus 的对象 params
      const params = {
        postIds: postIds,
        targetAuditStatus: 2,
        status: 2,
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        tenantId: parseInt(this.$route.query.tenantid),
      };

      jdh_qz_man_post_batch_audit(params)
        .then((res) => {
          this.$message({
            message: res ? "审核成功" : "审核失败",
            type: "success",
          });
        })
        .then(() => {
          this.getArticleList();
        });
    },
    handleReset() {
      this.$refs?.table?.concelEditSort?.();
      this.activeName = "all";
      this.searchParams = {
        title: "",
        auditStatus: "",
        postIds: "",
        communityIds: "",
        titleSearchKeyword: "",
        contentSearchKeyword: "",
        authorPin: "",
      };
      this.searchParams.auditStatus = "";
      // 人工干预 - 精选池请求列表（重置）
      if (
        this.$route.query.tenantid == 484 ||
        this.$route.query.tenantid == 492
      ) {
        jdh_qz_man_post_page({
          tenantId: parseInt(this.$route.query.tenantid),
          businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
          pageNo: 1,
          pageSize: this.paginationDataProduct.pageSize,
          // communityId:this.searchParams.communityId,
          title: this.searchParams.title,
          auditStatus: "",
          postIds: this.searchParams.postIds,
          communityIds: this.searchParams.communityIds,
          titleSearchKeyword: this.searchParams.titleSearchKeyword,
          // beginTime: utils.isEmpty(this.searchParams.contributeTime) ? null : utils.timetamp(Number(this.searchParams.contributeTime[0])), // 开始时间
          // endTime: utils.isEmpty(this.searchParams.contributeTime) ? null : utils.timetamp(Number(this.searchParams.contributeTime[1])), // 结束时间
          contentSearchKeyword: this.searchParams.contentSearchKeyword,
          authorPin: this.searchParams.authorPin,
          preSetTop: 1,
          status: 1,
        }).then((res) => {
          this.tableData.tableList.splice(0, this.tableData.tableList.length);
          res.data.map((item) => {
            item.submitTime = this.formatDate(item.submitTime);
            if (item.auditStatus == 0) {
              item.auditStatusCheck = "待审核";
            } else if (item.auditStatus == 1) {
              item.auditStatusCheck = "审核通过";
            } else if (item.auditStatus == 2) {
              item.auditStatusCheck = "审核拒绝";
            }
            this.tableData.tableList.push(item);
          });
          this.paginationDataProduct.total = res.totalCount;
          this.paginationDataProduct.currentPage = res.pageNo;
          this.paginationDataProduct.pageSize = res.pageSize;
          if (type != "pageChange" && this.isSelected) {
            this.isSelected = false;
          }
          console.log(
            "???",
            res.data,
            this.tableData,
            this.tableData.tableList[1]
          );
        });
      } else if (
        this.$route.query.tenantid == 287 ||
        this.$route.query.tenantid == 290
      ) {
        jdh_qz_man_query_post_featured({
          tenantId: parseInt(this.$route.query.tenantid),
          businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
          pageNo: 1,
          pageSize: this.paginationDataProduct.pageSize,
          // communityId:this.searchParams.communityId,
          title: this.searchParams.title,
          auditStatus: "",
          postId: this.searchParams.postIds,
          communityId: this.searchParams.communityIds,
          titleSearchKeyword: this.searchParams.titleSearchKeyword,
          contentSearchKeyword: this.searchParams.contentSearchKeyword,
          // beginTime: utils.isEmpty(this.searchParams.contributeTime) ? null : utils.timetamp(Number(this.searchParams.contributeTime[0])), // 开始时间
          // endTime: utils.isEmpty(this.searchParams.contributeTime) ? null : utils.timetamp(Number(this.searchParams.contributeTime[1])), // 结束时间
          authorPin: this.searchParams.authorPin,
          status: 1,
        })
          .then((res) => {
            this.tableData.tableList.splice(0, this.tableData.tableList.length);
            res.data.map((item) => {
              item.submitTime = this.formatDate(item.submitTime);
              if (item.auditStatus == 0) {
                item.auditStatusCheck = "待审核";
              } else if (item.auditStatus == 1) {
                item.auditStatusCheck = "审核通过";
              } else if (item.auditStatus == 2) {
                item.auditStatusCheck = "审核拒绝";
              }
              this.tableData.tableList.push(item);
            });
            this.paginationDataProduct.total = res.totalCount;
            this.paginationDataProduct.currentPage = res.pageNo;
            this.paginationDataProduct.pageSize = res.pageSize;
            if (type != "pageChange" && this.isSelected) {
              this.isSelected = false;
            }
            console.log(
              "???",
              res.data,
              this.tableData,
              this.tableData.tableList[1]
            );
          })
          .catch((err) => {
            this.$message.error(err.msg);
          });
      }
    },
    handleSearch() {
      if (this.activeName == "pending") {
        this.searchParams.auditStatusCheck = 0;
      } else if (this.activeName == "passed") {
        this.searchParams.auditStatusCheck = 1;
      } else if (this.activeName == "offline") {
        this.searchParams.auditStatusCheck = 2;
      } else {
        this.searchParams.auditStatusCheck = "";
      }
      this.$refs?.table?.concelEditSort?.();
      // 人工干预 - 精选池请求列表（搜索）
      if (
        this.$route.query.tenantid == 484 ||
        this.$route.query.tenantid == 492
      ) {
        const params = {
          tenantId: parseInt(this.$route.query.tenantid),
          businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
          pageNo: 1,
          pageSize: this.paginationDataProduct.pageSize,
          title: this.searchParams.title,
          auditStatus: "",
          postId: this.searchParams.postIds,
          communityId: this.searchParams.communityIds,
          titleSearchKeyword: this.searchParams.titleSearchKeyword,
          contentSearchKeyword: this.searchParams.contentSearchKeyword,
          // beginTime: utils.isEmpty(this.searchParams.contributeTime) ? null : utils.timetamp(Number(this.searchParams.contributeTime[0])), // 开始时间
          // endTime: utils.isEmpty(this.searchParams.contributeTime) ? null : utils.timetamp(Number(this.searchParams.contributeTime[1])), // 结束时间
          authorPin: this.searchParams.authorPin,
          preSetTop: 1,
          status: 1,
        };
        console.log("params", params);
        jdh_qz_man_post_page(params).then((res) => {
          this.tableData.tableList.splice(0, this.tableData.tableList.length);
          res.data.map((item) => {
            item.submitTime = this.formatDate(item.submitTime);
            if (item.auditStatus == 0) {
              item.auditStatusCheck = "待审核";
            } else if (item.auditStatus == 1) {
              item.auditStatusCheck = "审核通过";
            } else if (item.auditStatus == 2) {
              item.auditStatusCheck = "审核拒绝";
            }
            this.tableData.tableList.push(item);
          });
          this.paginationDataProduct.total = res.totalCount;
          this.paginationDataProduct.currentPage = res.pageNo;
          this.paginationDataProduct.pageSize = res.pageSize;

          console.log(
            "???",
            res.data,
            this.tableData,
            this.tableData.tableList[1]
          );
        });
      } else if (
        this.$route.query.tenantid == 287 ||
        this.$route.query.tenantid == 290
      ) {
        const params = {
          tenantId: parseInt(this.$route.query.tenantid),
          businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
          pageNo: 1,
          pageSize: this.paginationDataProduct.pageSize,
          title: this.searchParams.title,
          auditStatus: "",
          postId: this.searchParams.postIds,
          communityId: this.searchParams.communityIds,
          titleSearchKeyword: this.searchParams.titleSearchKeyword,
          contentSearchKeyword: this.searchParams.contentSearchKeyword,
          // beginTime: utils.isEmpty(this.searchParams.contributeTime) ? null : utils.timetamp(Number(this.searchParams.contributeTime[0])), // 开始时间
          // endTime: utils.isEmpty(this.searchParams.contributeTime) ? null : utils.timetamp(Number(this.searchParams.contributeTime[1])), // 结束时间
          authorPin: this.searchParams.authorPin,
          preSetTop: 1,
          status: 1,
        };
        console.log("params", params);
        jdh_qz_man_query_post_featured(params)
          .then((res) => {
            this.tableData.tableList.splice(0, this.tableData.tableList.length);
            res.data.map((item) => {
              item.submitTime = this.formatDate(item.submitTime);
              if (item.auditStatus == 0) {
                item.auditStatusCheck = "待审核";
              } else if (item.auditStatus == 1) {
                item.auditStatusCheck = "审核通过";
              } else if (item.auditStatus == 2) {
                item.auditStatusCheck = "审核拒绝";
              }
              this.tableData.tableList.push(item);
            });
            this.paginationDataProduct.total = res.totalCount;
            this.paginationDataProduct.currentPage = res.pageNo;
            this.paginationDataProduct.pageSize = res.pageSize;

            console.log(
              "???",
              res.data,
              this.tableData,
              this.tableData.tableList[1]
            );
          })
          .catch((err) => {
            this.$message.error(err.msg);
          });
      }
    },
    handleInitSearch(data) {
      if (this.searchParams.auditStatus == "待审核") {
        this.searchParams.auditStatusCheck = 0;
      } else if (this.searchParams.auditStatus == "审核通过") {
        this.searchParams.auditStatusCheck = 1;
      } else if (this.searchParams.auditStatus == "审核拒绝") {
        this.searchParams.auditStatusCheck = 2;
      } else {
        this.searchParams.auditStatusCheck = "";
      }
      jdh_qz_man_query_post_featured({
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        pageNo: 1,
        pageSize: this.paginationDataProduct.pageSize,
        title: this.searchParams.title,
        auditStatus: "",
        postId: this.searchParams.postIds,
        communityId: data,
        titleSearchKeyword: this.searchParams.titleSearchKeyword,
        contentSearchKeyword: this.searchParams.contentSearchKeyword,
        // beginTime: utils.isEmpty(this.searchParams.contributeTime) ? null : utils.timetamp(Number(this.searchParams.contributeTime[0])), // 开始时间
        // endTime: utils.isEmpty(this.searchParams.contributeTime) ? null : utils.timetamp(Number(this.searchParams.contributeTime[1])), // 结束时间
        authorPin: this.searchParams.authorPin,
        preSetTop: 1,
        status: 1,
      })
        .then((res) => {
          this.tableData.tableList.splice(0, this.tableData.tableList.length);
          res.data.map((item) => {
            item.submitTime = this.formatDate(item.submitTime);
            if (item.auditStatus == 0) {
              item.auditStatusCheck = "待审核";
            } else if (item.auditStatus == 1) {
              item.auditStatusCheck = "审核通过";
            } else if (item.auditStatus == 2) {
              item.auditStatusCheck = "审核拒绝";
            }
            this.tableData.tableList.push(item);
          });
          this.paginationDataProduct.total = res.totalCount;
          this.paginationDataProduct.currentPage = res.pageNo;
          this.paginationDataProduct.pageSize = res.pageSize;
          if (type != "pageChange" && this.isSelected) {
            this.isSelected = false;
          }
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },
    getBusinessId(key) {
      return getBusinessId(key);
    },
    communityList() {
      // jdh_community_list({
      //   pageNo: 1,
      //   pageSize: 100,
      //   status: 1,
      //   tenantId: parseInt(this.$route.query.tenantid),
      //   businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
      // }).then((res) => {
      //   console.log("jdh_community_list", res);
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.content-audit-tabel {
  position: relative;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;

  .import-btn {
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 11;

    .redTag {
      color: red;
    }
  }
}

.slot-item {
  span {
    margin: 0px 2px 0px 2px;
  }
}

:deep(.el-textarea__inner) {
  min-height: 130px !important;
  resize: none;
}

:deep(.el-form-item) {
  margin-bottom: 22px;
}

:deep(.modal-body) {
  margin-top: 30px;
}

.reasonDom {
  padding: 0 30px;
  height: 100px;
  line-height: 20px;
  font-size: 14px;
  color: rgba(44, 52, 67, 1);
  /*overflow: hidden;*/
  overflow-y: auto;
  max-height: 150px;
}

.freezeDom {
  /*margin-top: 30px;*/
  .freezeInp {
    max-height: 130px;
    max-width: 276px;

    // overflow: hidden;
    .el-input__count {
      background: rgba(0, 0, 0, 0);
      bottom: -30px;
    }
  }

  .mar-top30 {
    margin-top: 30px;
  }
}

.importBtn {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  margin-left: 5px;
}

.exportBtn {
  margin-left: 5px;

  span {
    margin-top: 5px;
    display: block;
    color: #abaaaa;
  }
}

.dropDown {
  margin-left: 10px;
}

.header-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header {
  font-size: 20px;
  font-weight: bold;
}

.form-container {
  height: 80vh;
  /* 设置固定高度 */
  overflow-y: auto;
  /* 启用垂直滚动条 */
}

:deep(.el-form-item__label) {
  font-weight: bold;
  /* 加粗 */
  margin-right: 20px;
  /* 右边距 */
}

.image-flex {
  display: flex;
  flex-wrap: wrap;
  /* 自动换行 */
  gap: 10px;
  /* 图片间距 */
}

.image-item {
  position: relative;
  width: calc(33.33% - 10px);
  /* 每行3个，减去间距 */
  height: 100px;
  /* 设置图片容器高度 */
  overflow: hidden;
  margin-bottom: 10px;
  /* 图片之间的垂直间距 */
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 图片覆盖容器 */
  cursor: pointer;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s;
}

.image-item:hover .image-overlay {
  opacity: 1;
}

.image-overlay .el-button {
  margin: 0 5px;
}

.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.input-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}

.button-group {
  display: flex;
  gap: 10px;
}

.multiSelect {
  display: flex;
  align-items: center;
  // justify-content: center;
  font-size: 16px;
  margin-bottom: 10px;
}

.select-blue {
  margin-right: 5px;
  // color: blue;
}

.select-white {
  margin-right: 5px;
  color: rgb(0, 0, 0);
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
  /* 确保背景色 */
}

.drawer-footer .el-button {
  margin-left: 10px;
}
</style>
